<template>
	<div class="stockTaking">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">新增盘点单</el-button>
			<el-button type="primary" size="small" @click="ondc('',2)">批量导出盘点单</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.trade_no" placeholder="盘点单编号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="50" align="center" header-align="center" fixed="left">
					</el-table-column>
					<el-table-column prop="trade_no" label="盘点单编号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="total_num" label="总数量" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="盘点日期" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="110px">
						<template slot-scope="scope">
							<div class="operation_i">
								<div>
									<span @click="onxq(scope.row)">详情</span>
									<span @click="ondc(scope.row.id,1)">导出</span>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="新增盘点单" :visible.sync="show" width="70%" :before-close="onclose">
			<scancodebuy v-if="show" @subscan="onsubscan"></scancodebuy>
		</el-dialog>
		
		<el-dialog title="盘点单详情" :visible.sync="show2" width="80%" :before-close="onclose2">
			<div class="table_page" v-if="show2">
				<div class="dheader">
					<div>盘点单编号:{{checkobj.trade_no}}</div>
					<div>盘点日期:{{checkobj.create_time_str}}</div>
				</div>
				<div class="table">
					<el-table :data="xqlist" style="width: 100%" border>
						<el-table-column prop="barcode" label="条码" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="brand" label="品牌" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="style_number" label="款号" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="size" label="尺码" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="stock" label="数量" align="center" header-align="center">
						</el-table-column>
					</el-table>
				</div>
				<div class="page">
					<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
						:current-page.sync="page1" :page-size="pageSize1" :total="total1" v-if="total1 > 0"
						@current-change="handleCurrentChange1" @size-change="handleSizeChange1">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		name: 'StockTaking',
		data() {
			return {
				list: [],
				selectionArr: [],
				page: 1,
				pageSize: 20,
				total: 0,

				show: false,
				show1: false,
				show2: false,

				formfilter: {
					trade_no: "",
					mydate: [],
					btime: "",
					etime: ""
				},

				filtershow: true,
				checkobj: {},
				ruleForm: {
					remark: ""
				},
				
				xqlist: [],
				page1: 1,
				pageSize1: 20,
				total1: 0,
			}
		},

		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					trade_no: "",
					mydate: [],
					btime: "",
					etime: ""
				};
				this.page = 1;
				this.onlist();
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/user_stock_taking_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
			},

			onclose() {
				this.show = false;
			},

			onsubscan() {
				this.onclose();
				this.onlist();
			},

			handleSelectionChange(val) {
				this.selectionArr = val;
			},
			
			onclose1() {
				this.checkobj = {};
				this.show1 = false;
			},
			
			onxq(obj) {
				this.checkobj = obj;
				this.show2 = true;
				this.ondetail();
			},
			
			onclose2() {
				this.checkobj = {};
				this.show2 = false;
				this.xqlist = [];
				this.page1 = 1;
				this.pageSize1 = 20;
				this.total1 = 0;
			},
			
			handleCurrentChange1() {
				this.ondetail();
			},
			
			handleSizeChange1(val) {
				this.page1 = 1;
				this.pageSize1 = val;
				this.ondetail();
			},
			
			ondetail() {
				var obj = {
					stock_taking_id: this.checkobj.id
				};
				obj.page = this.page1;
				obj.limit = this.pageSize1;
				
				this.$axios.post('api/user/user_stock_taking_detail', obj).then(res => {
					if (res.data.code == 0) {
						this.total1 = res.data.data.count;
						this.xqlist = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			ondc(id,n) {
				var ids = "";
				if(n == 2) {
					if(this.selectionArr.length == 0){
						this.$message.warning('请选择要导出的数据');
						return;
					}
					
					var arr = [];
					this.selectionArr.forEach((v,k)=>{
						arr.push(v.id);
					})
					
					ids = arr.join(',');
				}
				
				if(n == 1){
					ids = id;
				}
				var obj = {
					ids: ids
				};
				this.$axios.post('api/user/user_stock_taking_export', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.stockTaking {
		height: 100%;
	}

	.filterty .el-date-editor {
		width: 250px;
	}

	.tablebox {
		height: calc(100% - 104px);
	}
	
	.table_page {
		width: 100%;
	}
	
	.table_page .dheader {
		width: 100%;
		height: 40px;
		border: 1px solid #EBEEF5;
		border-bottom: none;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		>div {
			width: 50%;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		
		div:first-child {
			border-right: 1px solid #EBEEF5;
		}
	}
	
	.page {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/stockTaking.vue